export const getUrlQuery = () => {
    let url = window.location.href;
    const arrList = decodeURIComponent(url).split('?');
    const queryObj = {};
    let arr = null;
    for (let i = 1, len = arrList.length; i < len; i++) {
        const query = arrList[i];
        const queryArr = query.split('&');
        for (const item of queryArr) {
            arr = item.split('=');
            arr[1] && (queryObj[arr[0]] = arr[1]);
            if (arr[1] && arr[1].indexOf('#/') !== -1) {
                queryObj[arr[0]] = arr[1].split('#/')[0];
            }
        }
    }
    return queryObj;
};